import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CoreService, HttpService, BreadcrumbService } from '../services';
import { BreadcrumbModel, DateModel, QueovalDate, AgendaModelV3, SelectAgendaEvent, Calendar, DetailSelectAgendaEvent, BreadDik } from '../models';
import { PadLeft } from '../utilities';
import { NgbDateStruct, NgbCalendar, NgbDatepickerI18n, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AgendaQueovalServiceV3 } from './agenda.queoval.services';
import { I18n, CustomDatepickerI18n } from '../bodisplay/dynamictag/dynamictag-addon/datepicker/datepicker.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AnimationFactory, animate, style, AnimationBuilder } from '@angular/animations';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-agenda-v3',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide
})

export class AgendaComponentV3 implements OnInit {
  public LoadInfos: boolean = false;
  public datePickerModel: NgbDateStruct;
  public model: AgendaModelV3 = new AgendaModelV3;
  public modeAgenda: string;
  public loading: boolean = false;
  public refreshData: boolean = false;
  public firstDataLoaded: boolean = false;
  public srcSyncGoogle: SafeResourceUrl = '';
  public interval: any = 0;
  public modalReference: NgbModalRef | null = null;
  public currentSlide: number = 0;
  public selectsFilterables: number = 0;
  public oldModelForSaveDetails: Array<SelectAgendaEvent> = [];

  public timerTooglzHeaderOk: boolean = true;
  public displayHeader: boolean = true;

  public arrayFormat: { key: string; label: string; DayByWeek: number; mode: string }[] = []

  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();

  constructor(
    public indParam: CoreService,
    private http: HttpService,
    private service: AgendaQueovalServiceV3,
    private calendar: NgbCalendar,
    private domSanitizer: DomSanitizer,
    private modalService: NgbModal,
    private builder: AnimationBuilder,
    private breadCrumbService: BreadcrumbService
  ) { }


  ngOnInit(): void {

    this.indParam.showSplash(false);

    // get the agenda mode eventually stocked in localStorage
    this.model = new AgendaModelV3();
    this.model.listCalendars = [];
    const strIsPlanning: string = this.indParam.CurrentUrl.GetQueryParam('planning');
    this.model.isPlanning = strIsPlanning === '1';
    if (this.model.isPlanning !== this.service.isPlanning) {
      this.service.lstCalendarOwnerId = [];
    }
    this.service.isPlanning = strIsPlanning === '1';
    this.arrayFormat = [
      { key: '1D', label: '1 jour', DayByWeek: 1, mode: 'WEEK' },
      { key: '5D', label: '5 jours', DayByWeek: 5, mode: 'WEEK' },
      { key: '6D', label: '6 jours', DayByWeek: 6, mode: 'WEEK' },
      { key: '7D', label: '7 jours', DayByWeek: 7, mode: 'WEEK' }];

    if (this.model.isPlanning) {
      this.arrayFormat.push({ key: '7M', label: '1 mois(7 jours)', DayByWeek: 7, mode: 'MONTH' });
    } else {
      this.arrayFormat.push({ key: '5M', label: '1 mois(5 jours)', DayByWeek: 5, mode: 'MONTH' });
      this.arrayFormat.push({ key: '7M', label: '1 mois(7 jours)', DayByWeek: 7, mode: 'MONTH' });
    }

    const mode: string = this.getStorageKey('QueovalModeAgenda' + (this.model.isPlanning ? 'P' : 'A'));
    this.model.agendaMode = mode ? mode : "WEEK";
    const strDayByWeek: string = this.getStorageKey('QueovalDayByWeekAgenda' + (this.model.isPlanning ? 'P' : 'A'));
    this.model.dayByWeek = strDayByWeek ? Number.parseInt(strDayByWeek) : 7;
    this.SelectModeAgenda(this.model.dayByWeek, this.model.agendaMode);

    //#region set datepicker to TODAY
    if (this.service.IsComingFromABacktrack() && this.service.CalendarDate) {
      this.datePickerModel = this.service.CalendarDate;
    } else {
      this.datePickerModel = this.calendar.getToday();
      this.service.StringifiedCalendarDate = JSON.stringify(this.datePickerModel);
    }
    
    this.model.selectedDate = new QueovalDate(this.datePickerModel.year.toString(), this.datePickerModel.month.toString(), this.datePickerModel.day.toString());
    setTimeout(() => {
      $("select.custom-select[aria-label*='year']").val(this.datePickerModel.year);
      $("select.custom-select[aria-label*='month']").val(this.datePickerModel.month);
    }, 0);
    //#endregion
    const breadcrumb: BreadcrumbModel = this.breadCrumbService.Breadcrumb[this.breadCrumbService.Breadcrumb.length - 1];
    const isShortcut: boolean = breadcrumb.data.params.filter((el: BreadDik) => el.key === 'shortcut').length > 0;
    if (isShortcut) {
      this.service.lstCalendarOwnerId = [];
      // get eventual agenda's reservations from queryString
      this.service.lstCalendarObjectId = [];
      this.service.lstCalendarOfficeId = [];
      this.service.CalendarGroupMode = '';
    } else if (!this.service.IsComingFromABacktrack()) {
      // get eventual agenda's owner from queryString
      this.service.lstCalendarOwnerId = this.indParam.CurrentUrl.GetQueryParam('IdPersonne').split(',');
      // get eventual agenda's reservations from queryString
      this.service.lstCalendarObjectId = this.indParam.CurrentUrl.GetQueryParam('RESERV').split(',');
      this.service.lstCalendarOfficeId = this.indParam.CurrentUrl.GetQueryParam('BUREAU').split(',');
      this.service.CalendarGroupMode = this.indParam.CurrentUrl.GetQueryParam('GROUP');
    }
    this.service.lstCalendarOwnerId = this.service.lstCalendarOwnerId.length < 1 || (this.service.lstCalendarOwnerId.length === 1 && this.service.lstCalendarOwnerId[0] === '') ? [this.indParam.AppParams.LoggedUser.Ident] : this.service.lstCalendarOwnerId

    this.service.lstCalendarObjectId = this.service.lstCalendarObjectId.length < 1 || (this.service.lstCalendarObjectId.length === 1 && this.service.lstCalendarObjectId[0] === '') ? [] : this.service.lstCalendarObjectId

    this.service.lstCalendarOfficeId = this.service.lstCalendarOfficeId.length < 1 || (this.service.lstCalendarOfficeId.length === 1 && this.service.lstCalendarOfficeId[0] === '') ? [] : this.service.lstCalendarOfficeId



    // get the agenda types eventually stocked in localStorage
    let QueovalListAgenda: Array<SelectAgendaEvent> = [];



    //if (this.service.lstCalendarOwnerId.length === 1) {
    //  this.arrayFormat.push({ key: '5M', label: '1 mois(5 jours)', DayByWeek: 5, mode: 'MONTH' });
    //  this.arrayFormat.push({ key: '7M', label: '1 mois(7 jours)', DayByWeek: 7, mode: 'MONTH' });
    //}
    if (this.service.CalendarGroupMode) {
      this.GetModelForCalendarGroupMode();
    } else {
      if (this.service.lstCalendarObjectId.length > 0) {
        //#region agenda par reservations
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaObjects'));
        } catch (ex) { };
        this.model.CheckedSelectEvents = QueovalListAgenda && typeof QueovalListAgenda != 'string' ? QueovalListAgenda : [];

        this.service.lstCalendarObjectId.forEach((object: string) => {
          this.model.listCalendars.push(new Calendar('', object))
          this.http.getHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_OBJECT_DATA/${object}/`).subscribe(
            (result: AgendaModelV3) => {

              if (result && result.listCalendars && result.listCalendars.length === 1 && result.listCalendars[0].header) {
                const i: number = this.model.listCalendars.findIndex(e => e.calendarOBjectId === object);
                if (i > -1) {
                  this.model.listCalendars[i].calendarOwnerId = result.listCalendars[0].calendarOwnerId;
                  this.model.listCalendars[i].header.userImage = result.listCalendars[0].header.userImage;
                  this.model.listCalendars[i].header.userName = result.listCalendars[0].header.userName;
                }
              }
            });
          //"endregion
        });
      } else if (this.service.lstCalendarOfficeId.length > 0) {
        //#region agenda par reservations
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaOffice'));
        } catch (ex) { };
        this.model.CheckedSelectEvents = QueovalListAgenda && typeof QueovalListAgenda != 'string' ? QueovalListAgenda : [];

        this.service.lstCalendarOfficeId.forEach((office: string) => {
          this.model.listCalendars.push(new Calendar('', '', office))
          this.http.getHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_OFFICE_DATA/${office}/`).subscribe(
            (result: AgendaModelV3) => {

              if (result && result.listCalendars && result.listCalendars.length === 1 && result.listCalendars[0].header) {
                const i: number = this.model.listCalendars.findIndex(e => e.calendarOfficeId === office);
                if (i > -1) {
                  this.model.listCalendars[i].calendarOwnerId = result.listCalendars[0].calendarOwnerId;
                  this.model.listCalendars[i].header.userImage = result.listCalendars[0].header.userImage;
                  this.model.listCalendars[i].header.userName = result.listCalendars[0].header.userName;
                }
              }
            });
          //"endregion
        });
      } else {

        //#region mode agenda personne
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgenda'));
        } catch (ex) { };
        this.model.CheckedSelectEvents = QueovalListAgenda && typeof QueovalListAgenda != 'string' ? QueovalListAgenda : [];


        this.service.lstCalendarOwnerId.forEach((owner: string) => {
          this.model.listCalendars.push(new Calendar(owner))
          this.http.getHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_USER_DATA/${owner}/`).subscribe(
            (result: AgendaModelV3) => {
              if (result.ConnGoogle) {
                this.srcSyncGoogle = this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.indParam.AppParams.appUrl}Google/SynchroAgendaGoogle.aspx`);
              }
              if (result && result.listCalendars && result.listCalendars.length === 1 && result.listCalendars[0].header) {
                const i: number = this.model.listCalendars.findIndex(e => e.calendarOwnerId === owner);
                if (i > -1) {
                  this.model.listCalendars[i].header.userImage = result.listCalendars[0].header.userImage;
                  this.model.listCalendars[i].header.userName = result.listCalendars[0].header.userName;
                }
              }
            });
          //#endregion
        });
      }

      if (this.service.lstCalendarObjectId.length > 0) {

        //#region agenda par reservations
        this.model.Mode = 'GET_SELECT_OBJECTS';
        this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, this.model).subscribe(
          (result: AgendaModelV3) => {
            if (result) {
              for (let i: number = 0; i < this.model.listCalendars.length; i++) {
                const iValue = result.listCalendars.findIndex((e: Calendar) => e.calendarOBjectId === this.model.listCalendars[i].calendarOBjectId);
                if (iValue > -1) {
                  this.model.listCalendars[i].selectEvents = result.listCalendars[iValue].selectEvents;
                  this.selectsFilterables = this.model.listCalendars[i].selectEvents.filter(e => e.detail && e.detail.length > 0).length;
                }
              }
              this.GetAgenda();
            }
          });
        //#endregion
      } else if (this.service.lstCalendarOfficeId.length > 0) {

        //#region agenda par reservations
        this.model.Mode = 'GET_SELECT_OFFICE';
        this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, this.model).subscribe(
          (result: AgendaModelV3) => {
            if (result) {
              for (let i: number = 0; i < this.model.listCalendars.length; i++) {
                const iValue = result.listCalendars.findIndex((e: Calendar) => e.calendarOfficeId === this.model.listCalendars[i].calendarOfficeId);
                if (iValue > -1) {
                  this.model.listCalendars[i].selectEvents = result.listCalendars[iValue].selectEvents;
                  this.selectsFilterables = this.model.listCalendars[i].selectEvents.filter(e => e.detail && e.detail.length > 0).length;
                }
              }
              this.GetAgenda();
            }
          });
        //#endregion
      } else {

        //#region mode agenda personne
        this.model.Mode = 'GET_SELECT';
        this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, this.model).subscribe(
          (result: AgendaModelV3) => {
            if (result) {
              for (let i: number = 0; i < this.model.listCalendars.length; i++) {
                const iValue = result.listCalendars.findIndex((e: Calendar) => e.calendarOwnerId === this.model.listCalendars[i].calendarOwnerId);
                if (iValue > -1) {
                  this.model.listCalendars[i].selectEvents = result.listCalendars[iValue].selectEvents;
                  this.selectsFilterables = this.model.listCalendars[i].selectEvents.filter(e => e.detail && e.detail.length > 0).length;
                }
              }
              this.GetAgenda();
            }
          });
        //#endregion
      }
    }
  }



  public changeDisplayMode(value: string): void {
    const selectedMode: { key: string; label: string; DayByWeek: number; mode: string } = this.arrayFormat.find(e => e.key === value) as { key: string; label: string; DayByWeek: number; mode: string };
    this.model.agendaMode = selectedMode.mode
    this.model.dayByWeek = selectedMode.DayByWeek;
    this.SelectModeAgenda(this.model.dayByWeek, this.model.agendaMode);

    localStorage.setItem('QueovalModeAgenda' + (this.model.isPlanning ? 'P' : 'A'), this.model.agendaMode);
    localStorage.setItem('QueovalDayByWeekAgenda' + (this.model.isPlanning ? 'P' : 'A'), this.model.dayByWeek.toString());
    this.GetAgenda();
  }




  public isDisabled = (date: NgbDateStruct, current: { month: number }): boolean => {
    return date.month !== current.month;
  }

  public OnCheckSelect(callAgenda: boolean): void {
    this.model.CheckedSelectEvents = [];
    this.model.listCalendars[0].selectEvents.forEach((e: SelectAgendaEvent) => {
      if (e.isChecked) {
        this.model.CheckedSelectEvents.push(e);
      }
    })
    if (this.service.lstCalendarObjectId.length > 0) {
      localStorage.setItem('QueovalListAgendaObjects', JSON.stringify(this.model.CheckedSelectEvents));
    } else if (this.service.lstCalendarOfficeId.length > 0) {
      localStorage.setItem('QueovalListAgendaOffice', JSON.stringify(this.model.CheckedSelectEvents));
    } else if (this.service.CalendarGroupMode) {
      switch (this.service.CalendarGroupMode) {
        case 'CLIENT':
          localStorage.setItem('QueovalListAgendaClient', JSON.stringify(this.model.CheckedSelectEvents));
          break;
        case 'STAGIAIRE':
          localStorage.setItem('QueovalListAgendaStagiaire', JSON.stringify(this.model.CheckedSelectEvents));
          break;
        case 'FORMATEUR':
          localStorage.setItem('QueovalListAgendaFormateur', JSON.stringify(this.model.CheckedSelectEvents));
          break;
        case 'FORMATION':
          localStorage.setItem('QueovalListAgendaFormation', JSON.stringify(this.model.CheckedSelectEvents));
          break;
      }
    }
    else {
      localStorage.setItem('QueovalListAgenda', JSON.stringify(this.model.CheckedSelectEvents));
    }
    if (callAgenda) {
      this.GetAgenda();
    }
  }


  public onSelectPicker(e: any): void {
    const previousDate = JSON.parse(JSON.stringify(this.model.selectedDate));
    const changedDate: DateModel = e as DateModel;
    this.model.selectedDate = new QueovalDate(changedDate.year.toString(), changedDate.month.toString(), changedDate.day.toString());
    this.datePickerModel = { year: Number.parseInt(this.model.selectedDate.annee), month: Number.parseInt(this.model.selectedDate.mois), day: Number.parseInt(this.model.selectedDate.jour) };
    this.service.StringifiedCalendarDate = JSON.stringify(this.datePickerModel);
    if (this.NewDateChangeData(this.model.selectedDate, previousDate, this.model.agendaMode, this.model.dayByWeek)) {
      this.GetAgenda();
    }
  }

  public IsLoaded(loading: boolean): void {
    this.loading = loading;
  }

  public getBreadcrumb(breadcrumb: BreadcrumbModel): void {
    // this calls a "getBreadcrumb" method on the parent page
    this.sendBreadcrumb.emit(breadcrumb);
  }

  public CloseModalSyncGoogle(forceRefresh: boolean = false): void {
    if (this.interval !== 0) {
      clearInterval(this.interval);
      this.interval = 0;
    }
    let doc: any = null;
    const iframe: any = document.getElementById('iframe1');
    if (iframe) {
      doc = iframe.contentDocument || iframe.contentWindow.document;
    }
    if (doc) {
      const refresh: any = doc.getElementById('btnSlidUp');

      if (refresh || forceRefresh) {
        this.GetAgenda();
      }
    }
    this.RemoveModalReference();
  }

  public RemoveModalReference(): void {
    if (this.modalReference) {
      this.modalReference.close();
      this.modalReference = null;
    }
  }

  public CancelSelectEvents() {
    this.model.listCalendars.forEach(calendar => calendar.selectEvents = JSON.parse(JSON.stringify(this.oldModelForSaveDetails)));
  }


  public OpenFiltersModal(content: any, i: number): void {
    if (this.selectsFilterables > 0) {
      this.modalReference = this.modalService.open(content, { windowClass: 'bigest', backdrop: 'static', centered: true });
      this.oldModelForSaveDetails = JSON.parse(JSON.stringify(this.model.listCalendars[0].selectEvents));
      this.GoToSelectEventSelected(i, '0ms ease-in');
    }
  }
  public GoToSelectEventSelected(i: number, animation: string): void {
    const interval = setInterval(() => {
      const carousel: any = document.getElementById('carousel');
      if (carousel) {
        clearInterval(interval);
        if (i === this.model.listCalendars[0].selectEvents.length) return;
        this.currentSlide = i;
        let currentSlideIndex: number = i;
        for (let j = 0; j < i; j++) {
          if (!this.HasDetail(this.model.listCalendars[0].selectEvents[j])) {
            currentSlideIndex--;
          }
        }
        const offset = currentSlideIndex * carousel.getBoundingClientRect().width;
        const myAnimation: AnimationFactory = this.buildAnimation(offset, animation);
        myAnimation.create(carousel).play();
      }
    }, 100);
  }

  public OpenGoogleModal(content: any): void {
    if (this.srcSyncGoogle) {
      this.modalReference = this.modalService.open(content, { windowClass: 'bigest', backdrop: 'static', centered: true });
      let doc: any = null;
      const i = setInterval(() => {
        const iframe: any = document.getElementById('iframe1');
        if (iframe) {
          doc = iframe.contentDocument || iframe.contentWindow.document;
        }
        if (doc) {
          const body = doc.getElementsByTagName('body');
          if (body && body.length > 0) {
            body[0].style.paddingLeft = '15px';
            body[0].style.paddingRight = '15px';

            const queoval: any = doc.getElementById('btnToQueoval');
            const google: any = doc.getElementById('btnToGoogle');

            if (queoval) {
              queoval.addEventListener('click', () => {
                this.interval = setInterval(() => {
                  const refresh: any = doc.getElementById('btnSlidUp');

                  if (refresh) {
                    refresh.addEventListener('click', () => {
                      this.CloseModalSyncGoogle(true);
                    });

                    clearInterval(this.interval);
                    this.interval = 0;
                  }
                }, 100);
              });


            }
            if (google) {
              google.addEventListener('click', () => {
                this.interval = setInterval(() => {
                  const refresh: any = doc.getElementById('btnSlidUp');

                  if (refresh) {
                    refresh.addEventListener('click', () => {
                      this.CloseModalSyncGoogle(true);
                    });
                    clearInterval(this.interval);
                    this.interval = 0;
                  }
                }, 100);
              });
            }
            if (google && queoval) {
              clearInterval(i);
            }
          }
        }
      }, 100)
    }
  }

  public OnToogleHeader(): void {
    if (this.timerTooglzHeaderOk) {
      this.timerTooglzHeaderOk = false;

      setTimeout(() => { this.timerTooglzHeaderOk = true; }, 250);
      this.displayHeader = !this.displayHeader;
    }
  }

  public detailChecked(selectEvents: SelectAgendaEvent): boolean {
    return selectEvents.detail.findIndex((e: DetailSelectAgendaEvent) => e.list.findIndex(l => l.isChecked) != -1) != -1
  }

  public HasDetail(selectEvents: SelectAgendaEvent): boolean {
    return selectEvents.detail && selectEvents.detail.length > 0;
  }

  //public CalculCols(cols: number): number {
  //  return Math.floor(11 / cols);
  //}

  private buildAnimation(offset: number, animation: string) {
    return this.builder.build([
      animate(animation, style({ transform: `translateX(-${offset}px)` }))
    ]);
  }

  public GetAgenda(): void {
    if (this.service.CalendarGroupMode) {
      this.GetModelForCalendarGroupMode();
    } else {
      this.GetAgendaForCalendarStandarMode();
    }
  }


  private NewDateChangeData(qCurrentDate: QueovalDate, qPreviousDate: QueovalDate, mode: string, dayByWeek: number): boolean {
    //if (changedDate) {
    //#region calcul lundi, vendredi, samedi et dimanche à partir de la date sélectionnée + date précédente à partir de la DREF
    const previousDate: Date = new Date(Number.parseInt(qPreviousDate.annee), Number.parseInt(qPreviousDate.mois) - 1, Number.parseInt(qPreviousDate.jour));
    const currentDate: Date = new Date(Number.parseInt(qCurrentDate.annee), Number.parseInt(qCurrentDate.mois) - 1, Number.parseInt(qCurrentDate.jour));
    let day: number = previousDate.getDay();
    day = this.indParam.AppParams.culture.includes('fr') ? (day === 0 ? 6 : day - 1) : day;
    const firstDay: Date = new Date(previousDate.getFullYear(), previousDate.getMonth(), (previousDate.getDate() - day));
    const lastDay: Date = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() + 6);
    // #endregion
    const sameMonthInModeMonth: boolean = (mode === 'MONTH' && currentDate.getFullYear() === previousDate.getFullYear() && currentDate.getMonth() === previousDate.getMonth());
    const sameWeekInModeWeek: boolean = (mode === 'WEEK' && dayByWeek !== 1 && currentDate >= firstDay && currentDate <= lastDay);
    const sameDayInMode1J: boolean = (mode === 'WEEK' && dayByWeek === 1 && previousDate === currentDate);

    const dd: string = currentDate.getDate() ? PadLeft(currentDate.getDate(), 2) : '01';
    const mm: string = currentDate.getMonth() ? PadLeft(currentDate.getMonth() + 1, 2) : '01';
    const yy: string = currentDate.getFullYear() ? `${currentDate.getFullYear()}` : '0001';
    const NewselectedDate: QueovalDate = new QueovalDate(yy, mm, dd);
    if (this.model.selectedDate !== NewselectedDate) {
      if (!sameMonthInModeMonth && !sameWeekInModeWeek && !sameDayInMode1J) {
        return true;
      }
    }
    return false;
  }

  private getStorageKey(key: string): string {
    const dt: string | null = localStorage.getItem(key);
    return dt ? dt : '';
  }

  private SelectModeAgenda(DayByWeek: number, mode: string): void {
    const selectedMode: { key: string; label: string; DayByWeek: number; mode: string } | undefined = this.arrayFormat.find(e => e.DayByWeek === DayByWeek && e.mode === mode)
    if (selectedMode) {
      this.modeAgenda = selectedMode.key;
    } else {
      this.modeAgenda = '7D';
      this.model.dayByWeek = 7;
      this.model.agendaMode = 'WEEK';
    }
  }
  private GetModelForCalendarGroupMode(): void {
    let QueovalListAgenda: Array<SelectAgendaEvent> = [];

    switch (this.service.CalendarGroupMode) {
      case 'CLIENT':
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaClient'));
        } catch (ex) { };
        this.model.GroupMode = 'CUSTOMER';
        break;
      case 'STAGIAIRE':
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaStagiaire'));
        } catch (ex) { };
        this.model.GroupMode = 'TRAINEES';
        break;
        break;
      case 'FORMATEUR':
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaFormateur'));
        } catch (ex) { };
          this.model.GroupMode = 'PROVIDER';      
        break;
      case 'FORMATION':
        try {
          QueovalListAgenda = JSON.parse(this.getStorageKey('QueovalListAgendaFormation'));
        } catch (ex) { };
        this.model.GroupMode = 'TRAINING';      
        break;
    }
    this.model.CheckedSelectEvents = QueovalListAgenda && typeof QueovalListAgenda != 'string' ? QueovalListAgenda : [];
    this.model.Mode = 'GET_GROUP_LIST';

    this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3`, this.model).subscribe(
      (result: AgendaModelV3) => {
        if (result && result.listCalendars) {
          this.model.listCalendars = result.listCalendars;
          for (let i: number = 0; i < this.model.listCalendars.length; i++) {
            const iValue = result.listCalendars.findIndex((e: Calendar) => e.calendarOBjectId === this.model.listCalendars[i].calendarOBjectId);
            if (iValue > -1) {
              this.selectsFilterables = this.model.listCalendars[i].selectEvents.filter(e => e.detail && e.detail.length > 0).length;
            }
          }
          this.GetAgendaForCalendarStandarMode();
        }
      });
  }


  private GetAgendaForCalendarStandarMode() {
    this.model.Mode =
      this.service.lstCalendarObjectId.length > 0
        ? "GET_AGENDA_OBJETS"
        : this.service.lstCalendarOfficeId.length > 0
          ? "GET_AGENDA_OFFICE"
          : "GET_AGENDA";

    this.model.getInfos = false;
    const model2: AgendaModelV3 = JSON.parse(JSON.stringify(this.model));
    this.loading = true;
    this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, this.model).subscribe(
      (result: AgendaModelV3) => {

        this.model.BeginWorkAgenda = result.BeginWorkAgenda;
        this.model.EndWorkAgenda = result.EndWorkAgenda;
        if (result && result.listCalendars) {
          result.listCalendars.forEach((calendar: Calendar) => {
            let i: number = -1;
            if (this.service.lstCalendarObjectId.length > 0) {
              i = this.model.listCalendars.findIndex(e => e.calendarOBjectId === calendar.calendarOBjectId);
            } else if (this.service.lstCalendarOfficeId.length > 0) {
              i = this.model.listCalendars.findIndex(e => e.calendarOfficeId === calendar.calendarOfficeId);
            } else if (this.service.CalendarGroupMode) {
              i = this.model.listCalendars.findIndex(e => e.calendarGroupId === calendar.calendarGroupId);
            } else {
              i = this.model.listCalendars.findIndex(e => e.calendarOwnerId === calendar.calendarOwnerId);
            }
            if (i > -1) {
              this.model.listCalendars[i].height = calendar.height;
              this.model.listCalendars[i].maxEvents = calendar.maxEvents;
              this.model.listCalendars[i].body = calendar.body;
            }
          })
        }
        this.firstDataLoaded = true;
        this.refreshData = true;
        setTimeout(() => { this.refreshData = false; }, 0);
        //if (this.model.listCalendars.length > 1) {
        //  this.LoadInfos = true;
        //  model2.getInfos = true;
        //  this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, model2).subscribe(
        //    (result: AgendaModelV3) => {
        //      if (this.firstDataLoaded) {
        //        this.model.BeginWorkAgenda = result.BeginWorkAgenda;
        //        this.model.EndWorkAgenda = result.EndWorkAgenda;
        //        this.model.totalDays = result.totalDays;
        //        if (result && result.listCalendars) {
        //          result.listCalendars.forEach((calendar: Calendar) => {
        //            const i: number = this.model.listCalendars.findIndex(e => e.calendarOwnerId === calendar.calendarOwnerId);
        //            if (i > -1) {
        //              this.model.listCalendars[i].height = calendar.height;
        //              this.model.listCalendars[i].maxEvents = calendar.maxEvents;
        //              this.model.listCalendars[i].body = calendar.body;
        //              this.loading = false;
        //            }
        //          })
        //        }
        //        this.LoadInfos = false;
        //      }
        //    });
        //}
      });
    //if (this.model.listCalendars.length === 1) {
    this.LoadInfos = true;
    model2.getInfos = true;
    this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, model2).subscribe(
      (result: AgendaModelV3) => {
        let i = setInterval(() => {
          if (this.firstDataLoaded) {
            this.model.BeginWorkAgenda = result.BeginWorkAgenda;
            this.model.EndWorkAgenda = result.EndWorkAgenda;
            this.model.totalDays = result.totalDays;
            if (result && result.listCalendars) {
              result.listCalendars.forEach((calendar: Calendar) => {
                let i: number = -1;
                if (this.service.lstCalendarObjectId.length > 0) {
                  i = this.model.listCalendars.findIndex(e => e.calendarOBjectId === calendar.calendarOBjectId);
                } else if (this.service.lstCalendarOfficeId.length > 0) {
                  i = this.model.listCalendars.findIndex(e => e.calendarOfficeId === calendar.calendarOfficeId);
                } else if (this.service.CalendarGroupMode) {
                  i = this.model.listCalendars.findIndex(e => e.calendarGroupId === calendar.calendarGroupId);
                } else {
                  i = this.model.listCalendars.findIndex(e => e.calendarOwnerId === calendar.calendarOwnerId);
                }
                if (i > -1) {
                  this.model.listCalendars[i].height = calendar.height;
                  this.model.listCalendars[i].maxEvents = calendar.maxEvents;
                  this.model.listCalendars[i].body = calendar.body;
                  this.loading = false;
                }
              })
            }
            clearInterval(i);
            this.LoadInfos = false;
          }
        }, 10);
      });
    //}
  }
}
